import React, { useRef, useEffect, useState } from 'react';
import Image from 'next/image';
import closeIcon from '@assets/images/close-black.svg';
import useWindowSize from '@hooks/useWindowSize';
import styles from './Modal.module.css';
import ModalProps from './ModalTypes';

export default function ModalV2({
  children,
  isOpen,
  closePopup,
  childrenClass = '',
  showCloseButton = false,
  closeButtonClasses,
  hideScrollBar = false,
  title,
  showCloseButtonToTheRight = false,
}: ModalProps) {
  const modalRef = useRef<HTMLDivElement>(null);
  const { height: windowHeight } = useWindowSize();
  const [addScrollbar, setAddScrollbar] = useState<boolean>(false);

  useEffect(() => {
    if (hideScrollBar) {
      setAddScrollbar(false);
    } else if (modalRef.current && windowHeight && isOpen) {
      const modalHeight = modalRef.current.offsetHeight;
      if (modalHeight > windowHeight * 0.7) {
        setAddScrollbar(true);
      } else {
        setAddScrollbar(false);
      }
    }

    document.body.classList.toggle('overflow-hidden', isOpen);

    return () => {
      document.body.classList.remove('overflow-hidden');
    };
  }, [modalRef, windowHeight, isOpen, hideScrollBar]);

  return (
    <div>
      <div
        className={`${
          isOpen ? 'block' : `${styles.close} hidden`
        } fixed left-0 top-0 h-full w-full z-300 bg-rp-black-faded overflow-auto`}
        onClick={closePopup}
        onKeyDown={() => closePopup}
        role="button"
        tabIndex={0}
        aria-label="Close"
      />

      <div
        ref={modalRef}
        className={`${
          isOpen ? styles.open : styles.close
        } fixed bg-white flex flex-col items-center justify-between top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 rounded-xl transform-gpu max-h-90dvh max-w-90vw`}
      >
        <div className="flex justify-center items-center h-72px relative w-full">
          {showCloseButton ? (
            <div
              className={`absolute mt-1.5 ${
                showCloseButtonToTheRight ? 'right-22px' : 'left-22px'
              } ${closeButtonClasses}`}
            >
              <button type="button" onClick={closePopup}>
                <Image src={closeIcon} width={15} height={15} alt="Close" />
              </button>
            </div>
          ) : null}

          {title ? (
            <div className="max-w-70%">
              <p className="font-rp-pn-semi-bold text-custom-black text-base text-center truncate overflow-hidden whitespace-nowrap">
                {title}
              </p>
            </div>
          ) : null}
        </div>

        <div className={`${childrenClass} w-full ${addScrollbar ? 'overflow-y-scroll' : ''}`}>
          {children}
        </div>
      </div>
    </div>
  );
}
